import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  footer: {
    backgroundColor: '#112244',
    height: '150px',
    color: 'white',
    textAlign: 'center',
    paddingTop: '50px'
  },
  logo: {
    width: '30px',
    margin: '10px'
  },
  logos: {
    alignSelf: 'center'
  },
  text: {
    fontSize: '.8rem'
  }
});
